'use client';

import { ProfileSidebarItem } from '@eliadmin/core/src/components/profile/profile-sidebar-item';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useLocalePathname } from '@eliadmin/core/src/hooks/use-locale-pathname';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FaRegUserCircle } from 'react-icons/fa';
import { FiHeart, FiList, FiLock, FiLogOut, FiStar, FiUser } from 'react-icons/fi';
import { LuArrowLeftRight } from 'react-icons/lu';
import { MdOutlineShoppingBag } from 'react-icons/md';

export type SidebarItem = {
  name: string;
  icon: React.ElementType;
  href: string | (() => string);
  hardLink?: true;
  variant?: 'destructive';
};

export type ProfileSidebarProps = {
  sidebarItems?: SidebarItem[];
  className?: {
    root?: string;
  };
};

export function ProfileSidebar({ className }: ProfileSidebarProps) {
  const pathname = useLocalePathname();
  const templateSettings = useGlobalStore(state => state.templateSettings);
  const generalLayout = useGlobalStore(state => state.generalLayout);
  const { t } = useTranslations();

  return (
    <div
      className={cn(
        'mx-auto flex w-full max-w-[588px] flex-col gap-3',
        'ea-sidebar',
        className?.root,
      )}
    >
      {!!templateSettings.profile?.profile_info?.enabled && (
        <ProfileSidebarItem
          name={t('text491')}
          icon={FaRegUserCircle}
          href={() => ROUTES.MY_DATA()}
          pathname={pathname}
        />
      )}
      {!!templateSettings.profile?.orders?.enabled && (
        <ProfileSidebarItem
          name={t('text2361')}
          icon={MdOutlineShoppingBag}
          href={() => ROUTES.ORDERS()}
          pathname={pathname}
        />
      )}
      {!!templateSettings.profile?.change_password?.enabled && (
        <ProfileSidebarItem
          name={t('text115')}
          icon={FiLock}
          href={() => ROUTES.CHANGE_PASSWORD()}
          pathname={pathname}
        />
      )}
      {!!templateSettings.profile?.sign_out?.enabled && (
        <ProfileSidebarItem
          name={t('text258')}
          icon={FiLogOut}
          href={() => ROUTES.SIGN_OUT()}
          hardLink
          variant="destructive"
          pathname={pathname}
        />
      )}
    </div>
  );
}
